<div bsModal
     #editCustomerModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="editCustomerModal"
     aria-hidden="true" [config]="{backdrop: 'static', keyboard: false}">

    <div class="modal-dialog modal-lg search-customer-modal">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">
                    {{ "InvoiceInformation" | localize }}
                </h5>
                <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')" [disabled]="saving">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <form #editCustomerForm="ngForm"
                  role="form"
                  novalidate
                  class="form-validation"
                  *ngIf="active"
                  (submit)="editCustomer()">

                <div class="modal-body">
                    <div class="billing-information-container">
                        <div class="kt-portlet kt-portlet--mobile" *ngIf="mode === EditCustomerMode.Full">
                            <h5 class="kt-portlet__head-title">
                                {{ "Visitor" | localize }}
                            </h5>
                            <div class="kt-portlet__body">
                                <div class="row">
                                    <div class="form-group col-12 col-lg-4 col-sm-12">
                                        <label>
                                            <span translation="LegalName" source=""></span> <span *ngIf="options?.requiredLegalName">*</span>
                                        </label>
                                        <input id="LegalName"
                                               #legalNameInput="ngModel"
                                               type="text"
                                               name="legalName"
                                               class="form-control"
                                               [required]="options?.requiredLegalName"
                                               [ngClass]="{'edited':billingInfo.legalName}"
                                               [(ngModel)]="billingInfo.legalName"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredLegalName" [formCtrl]="legalNameInput"></validation-messages>
                                    </div>

                                    <div class="form-group col-12 col-lg-4 col-sm-6">
                                        <label for="contactName">
                                            <span translation="ContactName" source=""></span> <span *ngIf="options?.requiredContactName">*</span>
                                        </label>
                                        <input id="contactName"
                                               #contactNameInput="ngModel"
                                               type="text"
                                               name="contactName"
                                               class="form-control"
                                               [required]="options?.requiredContactName"
                                               [ngClass]="{'edited':billingInfo.contactName}"
                                               [(ngModel)]="billingInfo.contactName"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredContactName" [formCtrl]="contactNameInput"></validation-messages>
                                    </div>

                                    <div class="form-group col-12 col-lg-4 col-sm-9">
                                        <label for="Address">
                                            <span translation="Address" source=""></span> <span *ngIf="options?.requiredStreet">*</span></label>
                                        <textarea id="Address"
                                                  #addressInput="ngModel"
                                                  rows="1"
                                                  name="address"
                                                  [required]="options?.requiredStreet"
                                                  class="form-control"
                                                  [ngClass]="{'edited':billingInfo.address}"
                                                  [(ngModel)]="billingInfo.address"
                                                  maxlength="256"></textarea>

                                        <validation-messages *ngIf="options?.requiredStreet"
                                                             [formCtrl]="addressInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-3">
                                        <label for="houseNumber">
                                            <span translation="AddressHouseNumber" source=""></span> <span *ngIf="options?.requiredHouseNumber">*</span>
                                        </label>
                                        <input id="houseNumber"
                                               #houseNumberInput="ngModel"
                                               type="text"
                                               name="houseNumber"
                                               [required]="options?.requiredHouseNumber"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.addressHouseNumber}"
                                               [(ngModel)]="billingInfo.addressHouseNumber"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredHouseNumber"
                                                             [formCtrl]="houseNumberInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-4">
                                        <label for="postcode">
                                            <span translation="AddressPostcode" source=""></span> <span *ngIf="options?.requiredPostcode">*</span>
                                        </label>
                                        <input id="postcode"
                                               #postcodeInput="ngModel"
                                               type="text"
                                               name="postcode"
                                               [required]="options?.requiredPostcode"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.addressPostcode}"
                                               [(ngModel)]="billingInfo.addressPostcode"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredPostcode" [formCtrl]="postcodeInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-5">
                                        <label for="city">
                                            <span translation="AddressCity" source=""></span> <span *ngIf="options?.requiredCity">*</span>
                                        </label>
                                        <input id="city"
                                               #cityInput="ngModel"
                                               type="text"
                                               name="city"
                                               class="form-control"
                                               [required]="options?.requiredCity"
                                               [ngClass]="{'edited':billingInfo.addressCity}"
                                               [(ngModel)]="billingInfo.addressCity"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredCity" [formCtrl]="cityInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-3">
                                        <label for="country">
                                            <span translation="AddressCountry" source=""></span> <span *ngIf="options?.requiredCountry">*</span>
                                        </label>
                                        <input id="country"
                                               #countryInput="ngModel"
                                               type="text"
                                               name="country"
                                               [required]="options?.requiredCountry"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.addressCountry}"
                                               [(ngModel)]="billingInfo.addressCountry"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredCountry" [formCtrl]="countryInput"></validation-messages>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-portlet kt-portlet--mobile" *ngIf="mode === EditCustomerMode.Full || mode === EditCustomerMode.Invoice">
                            <h5 class="kt-portlet__head-title">
                                {{ "Invoice" | localize }}
                            </h5>
                            <div class="kt-portlet__body">
                                <div class="row">
                                    <div class="form-group col-12 col-lg-4 col-sm-6">
                                        <label for="invoiceContactName">
                                            <span translation="InvoiceContactName" source=""></span> <span *ngIf="options?.requiredInvoiceContactName">*</span>
                                        </label>
                                        <input id="invoiceContactName"
                                               #invoiceContactNameInput="ngModel"
                                               type="text"
                                               name="invoiceContactName"
                                               class="form-control"
                                               [required]="options?.requiredInvoiceContactName"
                                               [ngClass]="{'edited':billingInfo.invoiceContactName}"
                                               [(ngModel)]="billingInfo.invoiceContactName"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredInvoiceContactName" [formCtrl]="invoiceContactNameInput"></validation-messages>
                                    </div>

                                    <div class="form-group col-12 col-lg-4 col-sm-9">
                                        <label for="InvoiceAddress">
                                            <span translation="Address" source=""></span> <span *ngIf="options?.requiredInvoiceAddress">*</span>
                                        </label>
                                        <textarea id="InvoiceAddress"
                                                  #invoiceAddressInput="ngModel"
                                                  rows="1"
                                                  name="invoiceAddress"
                                                  [required]="options?.requiredInvoiceAddress"
                                                  class="form-control"
                                                  [ngClass]="{'edited':billingInfo.invoiceAddress}"
                                                  [(ngModel)]="billingInfo.invoiceAddress"
                                                  maxlength="256"></textarea>

                                        <validation-messages *ngIf="options?.requiredInvoiceAddress"
                                                             [formCtrl]="invoiceAddressInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-3">
                                        <label for="InvoiceHouseNumber">
                                            <span translation="AddressHouseNumber" source=""></span> <span *ngIf="options?.requiredInvoiceAddressHouseNumber">*</span>
                                        </label>
                                        <input id="InvoiceHouseNumber"
                                               #invoiceHouseNumber="ngModel"
                                               type="text"
                                               name="invoiceHouseNumber"
                                               [required]="options?.requiredInvoiceAddressHouseNumber"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.invoiceAddressHouseNumber}"
                                               [(ngModel)]="billingInfo.invoiceAddressHouseNumber"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredInvoiceAddressHouseNumber"
                                                             [formCtrl]="invoiceHouseNumber"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-4">
                                        <label for="InvoiceAddressPostcode">
                                            <span translation="AddressPostcode" source=""></span> <span *ngIf="options?.requiredInvoiceAddressPostcode">*</span>
                                        </label>
                                        <input id="InvoiceAddressPostcode"
                                               #invoiceAddressPostcodeInput="ngModel"
                                               type="text"
                                               name="invoiceAddressPostcode"
                                               [required]="options?.requiredInvoiceAddressPostcode"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.invoiceAddressPostcode}"
                                               [(ngModel)]="billingInfo.invoiceAddressPostcode"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredInvoiceAddressPostcode" [formCtrl]="invoiceAddressPostcodeInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-5">
                                        <label for="InvoiceAddressCity">
                                            <span translation="AddressCity" source=""></span> <span *ngIf="options?.requiredInvoiceAddressCity">*</span>
                                        </label>
                                        <input id="InvoiceAddressCity"
                                               #invoiceAddressCityInput="ngModel"
                                               type="text"
                                               name="invoiceAddressCity"
                                               class="form-control"
                                               [required]="options?.requiredInvoiceAddressCity"
                                               [ngClass]="{'edited':billingInfo.invoiceAddressCity}"
                                               [(ngModel)]="billingInfo.invoiceAddressCity"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredInvoiceAddressCity" [formCtrl]="invoiceAddressCityInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-3">
                                        <label for="InvoiceAddressCountry">
                                            <span translation="AddressCountry" source=""></span> <span *ngIf="options?.requiredInvoiceAddressCountry">*</span>
                                        </label>
                                        <input id="InvoiceAddressCountry"
                                               #invoiceAddressCountryInput="ngModel"
                                               type="text"
                                               name="invoiceAddressCountry"
                                               [required]="options?.requiredInvoiceAddressCountry"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.invoiceAddressCountry}"
                                               [(ngModel)]="billingInfo.invoiceAddressCountry"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredInvoiceAddressCountry" [formCtrl]="invoiceAddressCountryInput"></validation-messages>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-portlet kt-portlet--mobile" *ngIf="mode === EditCustomerMode.Full || mode === EditCustomerMode.Delivery">
                            <h5 class="kt-portlet__head-title">
                                {{ "Delivery" | localize }}
                            </h5>

                            <div class="kt-portlet__body">
                                <div class="row">
                                    <div class="form-group col-12 col-lg-4 col-sm-6">
                                        <label for="deliveryContactName">
                                            <span translation="DeliveryContactName" source=""></span> <span *ngIf="options?.requiredDeliveryContactName">*</span>
                                        </label>
                                        <input id="deliveryContactName"
                                               #deliveryContactNameInput="ngModel"
                                               type="text"
                                               name="deliveryContactName"
                                               class="form-control"
                                               [required]="options?.requiredDeliveryContactName"
                                               [ngClass]="{'edited':billingInfo.deliveryContactName}"
                                               [(ngModel)]="billingInfo.deliveryContactName"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredDeliveryContactName" [formCtrl]="deliveryContactNameInput"></validation-messages>
                                    </div>

                                    <div class="form-group col-12 col-lg-4 col-sm-9">
                                        <label for="DeliveryAddress">
                                            <span translation="Address" source=""></span> <span *ngIf="options?.requiredDeliveryAddress">*</span>
                                        </label>
                                        <textarea id="DeliveryAddress"
                                                  #deliveryAddressInput="ngModel"
                                                  rows="1"
                                                  name="deliveryAddress"
                                                  [required]="options?.requiredDeliveryAddress"
                                                  class="form-control"
                                                  [ngClass]="{'edited':billingInfo.deliveryAddress}"
                                                  [(ngModel)]="billingInfo.deliveryAddress"
                                                  maxlength="256"></textarea>

                                        <validation-messages *ngIf="options?.requiredDeliveryAddress"
                                                             [formCtrl]="deliveryAddressInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-3">
                                        <label for="DeliveryHouseNumber">
                                            <span translation="AddressHouseNumber" source=""></span> <span *ngIf="options?.requiredDeliveryAddressHouseNumber">*</span>
                                        </label>
                                        <input id="DeliveryHouseNumber"
                                               #deliveryHouseNumber="ngModel"
                                               type="text"
                                               name="deliveryHouseNumber"
                                               [required]="options?.requiredDeliveryAddressHouseNumber"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.deliveryAddressHouseNumber}"
                                               [(ngModel)]="billingInfo.deliveryAddressHouseNumber"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredDeliveryAddressHouseNumber"
                                                             [formCtrl]="deliveryHouseNumber"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-4">
                                        <label for="DeliveryAddressPostcode">
                                            <span translation="AddressPostcode" source=""></span> <span *ngIf="options?.requiredDeliveryAddressPostcode">*</span>
                                        </label>
                                        <input id="DeliveryAddressPostcode"
                                               #deliveryAddressPostcodeInput="ngModel"
                                               type="text"
                                               name="deliveryAddressPostcode"
                                               [required]="options?.requiredDeliveryAddressPostcode"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.deliveryAddressPostcode}"
                                               [(ngModel)]="billingInfo.deliveryAddressPostcode"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredDeliveryAddressPostcode" [formCtrl]="deliveryAddressPostcodeInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-5">
                                        <label for="DeliveryAddressCity">
                                            <span translation="AddressCity" source=""></span> <span *ngIf="options?.requiredDeliveryAddressCity">*</span>
                                        </label>
                                        <input id="DeliveryAddressCity"
                                               #deliveryAddressCityInput="ngModel"
                                               type="text"
                                               name="deliveryAddressCity"
                                               class="form-control"
                                               [required]="options?.requiredDeliveryAddressCity"
                                               [ngClass]="{'edited':billingInfo.deliveryAddressCity}"
                                               [(ngModel)]="billingInfo.deliveryAddressCity"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredDeliveryAddressCity" [formCtrl]="deliveryAddressCityInput"></validation-messages>
                                    </div>
                                    <div class="form-group col-12 col-lg-4 col-sm-3">
                                        <label for="DeliveryAddressCountry">
                                            <span translation="AddressCountry" source=""></span> <span *ngIf="options?.requiredDeliveryAddressCountry">*</span>
                                        </label>
                                        <input id="DeliveryAddressCountry"
                                               #deliveryAddressCountryInput="ngModel"
                                               type="text"
                                               name="invoiceAddressCountry"
                                               [required]="options?.requiredDeliveryAddressCountry"
                                               class="form-control"
                                               [ngClass]="{'edited':billingInfo.deliveryAddressCountry}"
                                               [(ngModel)]="billingInfo.deliveryAddressCountry"
                                               maxlength="64">

                                        <validation-messages *ngIf="options?.requiredDeliveryAddressCountry" [formCtrl]="deliveryAddressCountryInput"></validation-messages>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            [disabled]="saving"
                            class="btn btn-secondary"
                            (click)="close()">
                        <span translation="Cancel" source=""></span>
                    </button>
                    <button type="submit"
                            [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')"
                            class="btn btn-primary"
                            [disabled]="!editCustomerForm.form.valid
                                        || saving ">
                        <i class="fa fa-save"></i>
                        <span translation="Save" source=""></span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
